import { Component, inject, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ContactSupportFormComponent } from '../../components/contact-support-form/contact-support-form.component';
import { InfoModalComponent } from '../../../../parts/info-modal/info-modal.component';
import { BootstrapService } from '../../../../core/services/bootstrap.service';
import { SupportService } from '../../../../core/services/messaging/support.service';
import { ModalActions, ModalTypes } from '../../../../core/enums/base.enums';
import { SupportMessagingConstants } from '../../../../core/constants/messaging.constants';
import { PageTitleComponent } from '../../../../parts/page-title/page-title.component';

@Component({
    selector: 'ms-contact-support-page',
    standalone: true,
    imports: [PageTitleComponent, CommonModule, FontAwesomeModule, ContactSupportFormComponent, InfoModalComponent],
    templateUrl: './contact-support.page.html'
})
export class ContactSupportPage {

    private bootstrapService = inject(BootstrapService);
    private supportService = inject(SupportService);

    public readonly submitResultModalId = 'supportSubmitResultModal';

    public isSubmitting = signal<boolean>(false);

    @ViewChild(ContactSupportFormComponent) private supportForm?: ContactSupportFormComponent;
    @ViewChild('submitResultModal') private submitResultModal?: InfoModalComponent;

    public async attemptSubmit(): Promise<void> {
        if (!this.supportForm) {
            return;
        }
        if (!this.supportForm.isValid) {
            this.supportForm.markAllTouched();
            return;
        }

        this.isSubmitting.set(true);
        const result = await this.supportService.submitSupportTicket(this.supportForm.getValue());
        this.isSubmitting.set(false);

        if (result.success) {
            this.submitResultModal?.modalType.set(ModalTypes.Success);
            this.submitResultModal?.message.set(SupportMessagingConstants.SUBMIT_SUCCESS());
        } else {
            this.submitResultModal?.modalType.set(ModalTypes.Failure);
            this.submitResultModal?.message.set(result.message || SupportMessagingConstants.SUBMIT_FAILURE());
        }
        this.bootstrapService.manageModal(`#${this.submitResultModalId}`, ModalActions.Show);
    }

    public onResultAcknowledged(): void {
        // A successful submit clears the form so the user starts fresh; failures keep the entered content
        // so they can retry without retyping.
        if (this.submitResultModal?.modalType() === ModalTypes.Success) {
            this.supportForm?.reset();
        }
    }
}
